import { createModal, ModalPopover, NiceModal, useModal } from '@lessonup/ui-components';
import React, { useState } from 'react';
import { AudioPickerModalProps, HandleAddAudio, PickedAudioParams } from './AudioPickerModal.types';
import { AudioPickerModalContent } from './AudioPickerModalContent';

export const AudioPickerModal = createModal(
  ({
    modalDirection,
    modalAnchor,
    parentSelector,
    t,
    initialUrl,
    pinId,
    pinComponentId,
    performEditorUploadFile,
  }: AudioPickerModalProps): React.JSX.Element => {
    const modal = useModal();
    const [isUploading, setIsUploading] = useState(false);

    const handleAddAudio: HandleAddAudio = (params) => {
      modal.resolve(params);
      modal.hide();
    };

    const handleBeforeClose = () => {
      if (isUploading) {
        return false;
      }
      return true;
    };

    return (
      <ModalPopover
        modal={modal}
        contentLabel={t('audioPicker.ariaLabel')}
        onBeforeClose={handleBeforeClose}
        direction={modalDirection}
        modalAnchor={modalAnchor}
        parentSelector={parentSelector}
      >
        <AudioPickerModalContent
          handleAddAudio={handleAddAudio}
          t={t}
          closeModal={modal.hide}
          initialUrl={initialUrl}
          pinId={pinId}
          pinComponentId={pinComponentId}
          performEditorUploadFile={performEditorUploadFile}
          onUploadStateChange={setIsUploading}
        />
      </ModalPopover>
    );
  }
);

export const showAudioPickerModal = (props: AudioPickerModalProps): Promise<PickedAudioParams> =>
  NiceModal.show(AudioPickerModal, props);
